import { connect } from 'react-redux';
import Slider from '../../components/elements/slider/Slider';

const mapStateToProps = state => ({

});

export default connect(mapStateToProps, {

})(Slider);
